export default "__VITE_ASSET__xHJ8$X1p__"